import { render, staticRenderFns } from "./canvasText.vue?vue&type=template&id=200d0564&scoped=true&"
import script from "./canvasText.vue?vue&type=script&lang=js&"
export * from "./canvasText.vue?vue&type=script&lang=js&"
import style0 from "./canvasText.vue?vue&type=style&index=0&id=200d0564&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200d0564",
  null
  
)

export default component.exports